import { UNIVERSE_FONT } from './brand';

// ---------------------------------------------------------------------------
// THE UI FACE ON A MIGRATED PAGE, until Phase 0 of DESIGN.md §28 moves it
// into the theme: every piece of the page is set in the UI face, including
// the parts MUI would otherwise set in the theme's body face, and so are the
// page's LAYERS — menus, popovers, the filter sheet, tooltips, the date
// picker's dropdown — which render in portals outside the page's subtree,
// where a page-scoped rule cannot reach them. A page renders the layer styles
// through `GlobalStyles` while it is mounted (removed with it), so an old page
// opened next is untouched. Both rules retire with Phase 0.
// ---------------------------------------------------------------------------

// The page-scoped SCRIM is the same mechanism for the same reason (the
// theme's backdrop override reaches full opacity, §7), but it lives with the
// other surface recipes: `LAYER_SCRIM_STYLES` in `theme/universe/surfaceSx`.

export const PAGE_FONT_SX = {
  '& .MuiTypography-root, & .MuiButton-root, & .MuiTab-root, & .MuiInputBase-root, & .MuiFormControlLabel-label, & .MuiMenuItem-root':
    { fontFamily: UNIVERSE_FONT }
};

const LAYERS =
  '.MuiPopover-paper, .MuiPopper-root, .MuiDrawer-paper, .MuiTooltip-tooltip, .MuiDialog-paper, .ant-picker-dropdown';

export const LAYER_FONT_STYLES = {
  [LAYERS]: { fontFamily: UNIVERSE_FONT },
  [LAYERS.split(', ')
    .map((layer) =>
      [
        '.MuiTypography-root',
        '.MuiButton-root',
        '.MuiMenuItem-root',
        '.MuiInputBase-root',
        '.MuiFormControlLabel-label',
        '.MuiAutocomplete-option',
        '.MuiChip-label'
      ]
        .map((part) => `${layer} ${part}`)
        .join(', ')
    )
    .join(', ')]: { fontFamily: UNIVERSE_FONT }
};
